import React from "react";
import type { CostCenterAttributes } from "../../../types";
import { DataList, ListColumn, ListAction, Avatar, Icons } from "../../shared";

interface CostCentersListViewProps {
  costCenters: CostCenterAttributes[];
  onEdit: (costCenter: CostCenterAttributes) => void;
  onDelete: (id: number) => void;
  loading?: boolean;
}

export const CostCentersListView: React.FC<CostCentersListViewProps> = ({
  costCenters,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: ListColumn<CostCenterAttributes>[] = [
    {
      key: "name",
      label: "Centro de custo",
      width: "2fr",
      render: (item) => (
        <div className="flex items-center">
          <Avatar text={item.name} size="md" variant="emerald" />
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-900 dark:text-slate-200">{item.name}</p>
          </div>
        </div>
      ),
    },
  ];

  const actions: ListAction<CostCenterAttributes>[] = [
    {
      label: "Editar",
      icon: <Icons.Edit />,
      onClick: (item) => onEdit(item),
      className:
        "p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200",
      title: "Editar centro de custo",
      disabled: () => loading,
    },
    {
      label: "Excluir",
      icon: <Icons.Delete />,
      onClick: (item) => onDelete(item.id),
      className:
        "p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200",
      title: "Excluir centro de custo",
      disabled: () => loading,
    },
  ];

  return (
    <DataList<CostCenterAttributes>
      data={costCenters}
      columns={columns}
      actions={actions}
      keyExtractor={(item) => item.id}
      emptyMessage="Nenhum centro de custo encontrado"
      loading={loading}
      onRowClick={(item) => onEdit(item)}
    />
  );
};
